import { ModelPortfoliosFacade } from 'src/app/store/model-portfolios/facade/model-portfolios.facade';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromModelPortfolios from 'src/app/store/model-portfolios/reducers/model-portfolios.reducer';
import { ModelPortfoliosEffects } from 'src/app/store/model-portfolios/effects/model-portfolios.effects';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('modelPortfolios', fromModelPortfolios.ModelPortfoliosReducer),
    EffectsModule.forFeature([ModelPortfoliosEffects]),
    CommonModule
  ],
  providers: [
    ModelPortfoliosEffects,
    ModelPortfoliosFacade
  ]
})
export class ModelPortfoliosStoreModule { }
